const estimates = {
  en: {
    'estimates.title': 'Estimates & Valuations',
    'estimates.subtitle': 'Turn a request into a billable estimate and compare it with actual and AI-valued cost',
    'estimates.list': 'Estimates',
    'estimates.create': 'New Estimate',
    'estimates.createNew': 'Create Estimate',
    'estimates.createRequest': 'New Request',
    'estimates.edit': 'Edit Estimate',
    'estimates.searchPlaceholder': 'Search estimates...',
    'estimates.allStatuses': 'All Statuses',
    'estimates.allTypes': 'All Types',
    'estimates.type': 'Type',
    'estimates.typeRequest': 'Request',
    'estimates.typeProject': 'Project',
    'estimates.typeTask': 'Task',
    'estimates.typeTimeEntry': 'Time Entry',
    'estimates.status': 'Status',
    'estimates.statusDraft': 'Draft',
    'estimates.statusEstimated': 'Estimated',
    'estimates.statusShared': 'Shared',
    'estimates.statusArchived': 'Archived',
    'estimates.titleField': 'Title',
    'estimates.titlePlaceholder': 'Short name for this estimate',
    'estimates.requestText': 'Request / Scope',
    'estimates.requestPlaceholder': 'Describe the work to be estimated...',
    'estimates.client': 'Client',
    'estimates.project': 'Project',
    'estimates.selectClient': 'Select a client (optional)',
    'estimates.selectProject': 'Select a project (optional)',
    'estimates.attachTo': 'Attach to',
    'estimates.attachRequest': 'Standalone request',
    'estimates.attachProject': 'Project',
    'estimates.attachTask': 'Task',
    'estimates.attachTimeEntry': 'Time entry',
    'estimates.entityId': 'Target ID',
    'estimates.entityIdHint': 'ID of the project, task or time entry to attach to',
    'estimates.estimatedHours': 'Estimated hours',
    'estimates.rate': 'Rate',
    'estimates.currency': 'Currency',
    'estimates.estimatedCost': 'Estimated cost',
    'estimates.manualHours': 'Manual hours',
    'estimates.manualHoursHint': 'Enter hours yourself; AI is optional.',
    'estimates.estimateLabel': 'Estimate',
    'estimates.actualLabel': 'Actual',
    'estimates.valuationLabel': 'AI valuation',
    'estimates.variance': 'Variance',
    'estimates.varianceHint': 'Actual minus estimate',
    'estimates.hoursShort': 'h',
    'estimates.entries': 'entries',
    'estimates.runEstimate': 'Estimate with AI',
    'estimates.runValuation': 'AI valuation',
    'estimates.download': 'Download PDF',
    'estimates.delete': 'Delete',
    'estimates.view': 'View',
    'estimates.close': 'Close',
    'estimates.save': 'Save',
    'estimates.cancel': 'Cancel',
    'estimates.details': 'Estimate details',
    'estimates.aiRationale': 'AI rationale',
    'estimates.valuationRationale': 'Valuation rationale',
    'estimates.confidence': 'Confidence',
    'estimates.confidenceLow': 'Low',
    'estimates.confidenceMedium': 'Medium',
    'estimates.confidenceHigh': 'High',
    'estimates.aiModel': 'Model',
    'estimates.clientAmount': 'Client amount',
    'estimates.fixedPrice': 'Fixed price',
    'estimates.aiDisabledTitle': 'AI is unavailable',
    'estimates.aiDisabledHint': 'AI estimates are disabled or not configured. You can still enter hours manually.',
    'estimates.noEstimates': 'No estimates found',
    'estimates.noEstimatesHint': 'Create an estimate to get started.',
    'estimates.confirmDelete': 'Are you sure you want to delete this estimate? This cannot be undone.',
    'estimates.loadError': 'Failed to load estimates',
    'estimates.toastCreated': 'Estimate created',
    'estimates.toastUpdated': 'Estimate updated',
    'estimates.toastDeleted': 'Estimate deleted',
    'estimates.toastCreateFailed': 'Failed to create estimate',
    'estimates.toastUpdateFailed': 'Failed to update estimate',
    'estimates.toastDeleteFailed': 'Failed to delete estimate',
    'estimates.toastEstimateRun': 'AI estimate generated',
    'estimates.toastEstimateFailed': 'AI estimate failed',
    'estimates.toastValuationRun': 'AI valuation generated',
    'estimates.toastValuationFailed': 'AI valuation failed',
    'estimates.downloadError': 'Failed to download the estimate',

    'admin.ai.title': 'AI Estimates',
    'admin.ai.subtitle': 'Configure the server-side AI used for estimates and valuations',
    'admin.ai.enabled': 'Enable AI estimates',
    'admin.ai.enabledHint': 'When disabled, users can still enter estimated hours manually.',
    'admin.ai.model': 'Model',
    'admin.ai.modelHint': 'Provider-namespaced model id, e.g. anthropic/claude-sonnet-4.5',
    'admin.ai.modelPlaceholder': 'anthropic/claude-sonnet-4.5',
    'admin.ai.defaultModel': 'Environment default',
    'admin.ai.configured': 'API key configured',
    'admin.ai.notConfigured': 'API key missing',
    'admin.ai.keyManagedInEnv': 'The API key and base URL are managed in scripts/.env and are never sent to the browser.',
    'admin.ai.test': 'Test connection',
    'admin.ai.testing': 'Testing...',
    'admin.ai.testSuccess': 'AI provider responded successfully',
    'admin.ai.testFailed': 'AI test failed',
    'admin.ai.save': 'Save AI settings',
    'admin.ai.saved': 'AI settings saved',
    'admin.ai.loadError': 'Failed to load AI settings',

    'admin.data.title': 'Backup & Transfer',
    'admin.data.subtitle': 'Export this environment\'s data, or replace it with an export file from another environment (for example, copy live data into your local test site).',
    'admin.data.warning': 'Importing REPLACES users, clients, projects, tasks, time entries, invoices, payments and estimates in THIS environment. It cannot be undone. Only import into a test site, never into the live site. Environment settings (AI config) and login sessions are not included.',
    'admin.data.exportLabel': 'Export data',
    'admin.data.exportHint': 'Downloads a JSON file with all business tables.',
    'admin.data.export': 'Export',
    'admin.data.exporting': 'Exporting...',
    'admin.data.exported': 'Export downloaded',
    'admin.data.exportFailed': 'Export failed',
    'admin.data.importLabel': 'Import data',
    'admin.data.importHint': 'Select an export file, then type the confirmation phrase to replace this environment\'s data.',
    'admin.data.confirmLabel': 'Type REPLACE ALL to confirm',
    'admin.data.import': 'Replace data',
    'admin.data.importing': 'Importing...',
    'admin.data.imported': 'Import complete ({count} rows)',
    'admin.data.importFailed': 'Import failed',
    'admin.data.invalidFile': 'That file is not a valid TimeClock export',
  },

  es: {
    'estimates.title': 'Presupuestos y valoraciones',
    'estimates.subtitle': 'Convierte una solicitud en un presupuesto facturable y compáralo con el costo real y el valorado por IA',
    'estimates.list': 'Presupuestos',
    'estimates.create': 'Nuevo presupuesto',
    'estimates.createNew': 'Crear presupuesto',
    'estimates.createRequest': 'Nueva solicitud',
    'estimates.edit': 'Editar presupuesto',
    'estimates.searchPlaceholder': 'Buscar presupuestos...',
    'estimates.allStatuses': 'Todos los estados',
    'estimates.allTypes': 'Todos los tipos',
    'estimates.type': 'Tipo',
    'estimates.typeRequest': 'Solicitud',
    'estimates.typeProject': 'Proyecto',
    'estimates.typeTask': 'Tarea',
    'estimates.typeTimeEntry': 'Registro de tiempo',
    'estimates.status': 'Estado',
    'estimates.statusDraft': 'Borrador',
    'estimates.statusEstimated': 'Estimado',
    'estimates.statusShared': 'Compartido',
    'estimates.statusArchived': 'Archivado',
    'estimates.titleField': 'Título',
    'estimates.titlePlaceholder': 'Nombre corto para este presupuesto',
    'estimates.requestText': 'Solicitud / Alcance',
    'estimates.requestPlaceholder': 'Describe el trabajo a estimar...',
    'estimates.client': 'Cliente',
    'estimates.project': 'Proyecto',
    'estimates.selectClient': 'Selecciona un cliente (opcional)',
    'estimates.selectProject': 'Selecciona un proyecto (opcional)',
    'estimates.attachTo': 'Vincular a',
    'estimates.attachRequest': 'Solicitud independiente',
    'estimates.attachProject': 'Proyecto',
    'estimates.attachTask': 'Tarea',
    'estimates.attachTimeEntry': 'Registro de tiempo',
    'estimates.entityId': 'ID de destino',
    'estimates.entityIdHint': 'ID del proyecto, tarea o registro de tiempo al que vincular',
    'estimates.estimatedHours': 'Horas estimadas',
    'estimates.rate': 'Tarifa',
    'estimates.currency': 'Moneda',
    'estimates.estimatedCost': 'Costo estimado',
    'estimates.manualHours': 'Horas manuales',
    'estimates.manualHoursHint': 'Introduce las horas tú mismo; la IA es opcional.',
    'estimates.estimateLabel': 'Presupuesto',
    'estimates.actualLabel': 'Real',
    'estimates.valuationLabel': 'Valoración por IA',
    'estimates.variance': 'Variación',
    'estimates.varianceHint': 'Real menos presupuesto',
    'estimates.hoursShort': 'h',
    'estimates.entries': 'registros',
    'estimates.runEstimate': 'Estimar con IA',
    'estimates.runValuation': 'Valoración por IA',
    'estimates.download': 'Descargar PDF',
    'estimates.delete': 'Eliminar',
    'estimates.view': 'Ver',
    'estimates.close': 'Cerrar',
    'estimates.save': 'Guardar',
    'estimates.cancel': 'Cancelar',
    'estimates.details': 'Detalles del presupuesto',
    'estimates.aiRationale': 'Razonamiento de la IA',
    'estimates.valuationRationale': 'Razonamiento de la valoración',
    'estimates.confidence': 'Confianza',
    'estimates.confidenceLow': 'Baja',
    'estimates.confidenceMedium': 'Media',
    'estimates.confidenceHigh': 'Alta',
    'estimates.aiModel': 'Modelo',
    'estimates.clientAmount': 'Importe al cliente',
    'estimates.fixedPrice': 'Precio fijo',
    'estimates.aiDisabledTitle': 'La IA no está disponible',
    'estimates.aiDisabledHint': 'Los presupuestos con IA están desactivados o sin configurar. Aún puedes introducir horas manualmente.',
    'estimates.noEstimates': 'No se encontraron presupuestos',
    'estimates.noEstimatesHint': 'Crea un presupuesto para empezar.',
    'estimates.confirmDelete': '¿Seguro que deseas eliminar este presupuesto? No se puede deshacer.',
    'estimates.loadError': 'No se pudieron cargar los presupuestos',
    'estimates.toastCreated': 'Presupuesto creado',
    'estimates.toastUpdated': 'Presupuesto actualizado',
    'estimates.toastDeleted': 'Presupuesto eliminado',
    'estimates.toastCreateFailed': 'No se pudo crear el presupuesto',
    'estimates.toastUpdateFailed': 'No se pudo actualizar el presupuesto',
    'estimates.toastDeleteFailed': 'No se pudo eliminar el presupuesto',
    'estimates.toastEstimateRun': 'Presupuesto con IA generado',
    'estimates.toastEstimateFailed': 'Falló el presupuesto con IA',
    'estimates.toastValuationRun': 'Valoración con IA generada',
    'estimates.toastValuationFailed': 'Falló la valoración con IA',
    'estimates.downloadError': 'No se pudo descargar el presupuesto',

    'admin.ai.title': 'Presupuestos con IA',
    'admin.ai.subtitle': 'Configura la IA del servidor para presupuestos y valoraciones',
    'admin.ai.enabled': 'Activar presupuestos con IA',
    'admin.ai.enabledHint': 'Si se desactiva, los usuarios aún pueden introducir horas manualmente.',
    'admin.ai.model': 'Modelo',
    'admin.ai.modelHint': 'Id de modelo con proveedor, p. ej. anthropic/claude-sonnet-4.5',
    'admin.ai.modelPlaceholder': 'anthropic/claude-sonnet-4.5',
    'admin.ai.defaultModel': 'Predeterminado del entorno',
    'admin.ai.configured': 'Clave de API configurada',
    'admin.ai.notConfigured': 'Falta la clave de API',
    'admin.ai.keyManagedInEnv': 'La clave de API y la URL base se gestionan en scripts/.env y nunca se envían al navegador.',
    'admin.ai.test': 'Probar conexión',
    'admin.ai.testing': 'Probando...',
    'admin.ai.testSuccess': 'El proveedor de IA respondió correctamente',
    'admin.ai.testFailed': 'La prueba de IA falló',
    'admin.ai.save': 'Guardar configuración de IA',
    'admin.ai.saved': 'Configuración de IA guardada',
    'admin.ai.loadError': 'No se pudo cargar la configuración de IA',

    'admin.data.title': 'Copia y transferencia',
    'admin.data.subtitle': 'Exporta los datos de este entorno o reemplázalos con un archivo de otro entorno (por ejemplo, copia los datos de producción a tu sitio de prueba local).',
    'admin.data.warning': 'La importación REEMPLAZA usuarios, clientes, proyectos, tareas, registros de tiempo, facturas, pagos y presupuestos en ESTE entorno. No se puede deshacer. Importa solo en un sitio de prueba, nunca en el sitio en vivo. No se incluyen los ajustes del entorno (configuración de IA) ni las sesiones.',
    'admin.data.exportLabel': 'Exportar datos',
    'admin.data.exportHint': 'Descarga un archivo JSON con todas las tablas de negocio.',
    'admin.data.export': 'Exportar',
    'admin.data.exporting': 'Exportando...',
    'admin.data.exported': 'Exportación descargada',
    'admin.data.exportFailed': 'La exportación falló',
    'admin.data.importLabel': 'Importar datos',
    'admin.data.importHint': 'Selecciona un archivo de exportación y escribe la frase de confirmación para reemplazar los datos de este entorno.',
    'admin.data.confirmLabel': 'Escribe REPLACE ALL para confirmar',
    'admin.data.import': 'Reemplazar datos',
    'admin.data.importing': 'Importando...',
    'admin.data.imported': 'Importación completa ({count} filas)',
    'admin.data.importFailed': 'La importación falló',
    'admin.data.invalidFile': 'Ese archivo no es una exportación válida de TimeClock',
  },
};

export default estimates;
